<template>
  <div class="home">
    <div class="home_banner">
      <el-carousel height="600px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <div class="home_banner_swiper" @click="goDetails(item)" :style="`background-image:url(${$imgUrl + item.image_url})`"></div>
        </el-carousel-item>

      </el-carousel>
    </div>
    <div class="home_star">
      <div class="home_star_header">
        <div class="home_star_header_left" @click="goCarpooling()">
          <img src="../../assets/order/pin.png" alt="">
          <p>专线物流下单</p>
        </div>
    <!--    <div class="home_star_header_center" @click="goVehicle()">
          <img src="../../assets/order/zheng.png" alt="">
          <p>整车物流下单</p>
        </div> -->
        <div class="home_star_header_right">
          <img class="home_star_header_right_icon" src="../../assets/order/search_logo.png">
          <div class="home_star_header_right_msg">运单查询</div>
          <el-input class="home_star_header_right_input" placeholder="请输入运单编号" size="mini" v-model="value"></el-input>
          <div class="home_star_header_right_btn" @click="search">搜索</div>
        </div>
      </div>
    <!--  <div class="home_star_title">
        明星产品
      </div>
      <div class="home_star_english">STAR PRODUCTS</div>
      <div class="home_star_content">
        <div class="home_star_content_item">
          <img src="../../assets/home/car1.png" alt="">
          <div class="home_star_content_item_title">整车物流</div>
          <div class="home_star_content_item_msg"><三分钟，五份报价></div>
        </div>
        <div class="home_star_content_item">
          <img src="../../assets/home/car2.png" alt="">
          <div class="home_star_content_item_title">次日达拼车/专线物流</div>
          <div class="home_star_content_item_msg"><2吨起运，跨省次日达></div>
        </div>
        <div class="home_star_content_item">
          <img src="../../assets/home/car3.png" alt="">
          <div class="home_star_content_item_title">隔日达拼车/专线物流</div>
          <div class="home_star_content_item_msg"><直达国内市县，不中转></div>
        </div>
      </div> -->
    </div>
    <div class="home_reason">
      <div class="home_reason_title">
        选择扬师傅的理由
      </div>
      <div class="home_reason_english">PLATFORM ADVANTAGES</div>
      <div class="home_reason_content">
        <div class="home_reason_content_item">
          <img class="home_reason_content_item_img" src="../../assets/home/home_logo1.png" alt="">
          <div class="home_reason_content_item_title">专属客服</div>
          <div class="home_reason_content_item_msg">7*24小时服务</div>
        </div>
        <div class="home_reason_content_item">
          <img class="home_reason_content_item_img" src="../../assets/home/home_logo2.png" alt="">
          <div class="home_reason_content_item_title">性价比高</div>
          <div class="home_reason_content_item_msg">价格合理每一分</div>
        </div>
        <div class="home_reason_content_item">
          <img class="home_reason_content_item_img" src="../../assets/home/home_logo3.png" alt="">
          <div class="home_reason_content_item_title">信息化透明</div>
          <div class="home_reason_content_item_msg">专线与司机直接对接</div>
        </div>
        <div class="home_reason_content_item">
          <img class="home_reason_content_item_img" src="../../assets/home/home_logo4.png" alt="">
          <div class="home_reason_content_item_title">平台监管</div>
          <div class="home_reason_content_item_msg">智能监控保障服务质量</div>
        </div>
      </div>
    </div>
    <div class="home_culture" :style="`background-image:url(${bgUrl2})`">
      <div class="home_culture_title">
        扬师傅一贯坚持的企业文化
      </div>
      <div class="home_culture_english">IMPLEMENTING CORPORATE CULTURE</div>
      <div class="home_culture_content">
        <div class="home_culture_content_left">
          <p>企业文化是企业的灵魂，是构成企业核心竞争力的关键所在，是企业发展的原动力。</p>
          <p> 优秀的企业文化理念能为公司创造良好的企业环境，为员工树立正确的价值观，为企业赢得客户与未来。</p>
          <p> 企业文化理念是扬师傅发展的灵魂桥梁，是增强企业的凝聚力、向心力，激励员工开拓创新、建功立业的斗志。扬师傅将企业文化理念渗透到每个员工的心中，以此不断提升主人翁意识，增强企业使命感，带领全体人员共同进步。</p>
        </div>
        <div class="home_culture_content_right">
          <div class="home_culture_content_right_items">
            <div class="home_culture_content_right_items_item">
              <div>
                <p class="home_culture_content_right_items_item_title">服务理念</p>
                <p class="home_culture_content_right_items_item_msg">安全、准时、快捷、经济、优质</p>
              </div>
            </div>
            <div class="home_culture_content_right_items_item">
              <div>
                <p class="home_culture_content_right_items_item_title">经营理念</p>
                <p class="home_culture_content_right_items_item_msg">客户满意、员工满意、公司满意</p>
              </div>
            </div>
          </div>
          <div class="home_culture_content_right_items" style="position:relative;left:-132px;top:40px;">
            <div class="home_culture_content_right_items_item">
              <div>
                <p class="home_culture_content_right_items_item_title">RIRST价值观</p>
                <p class="home_culture_content_right_items_item_msg">诚信、正直、责任、服务、团队</p>
              </div>
            </div>
            <div class="home_culture_content_right_items_item">
              <div style="left:-20px;top:38px">
                <p class="home_culture_content_right_items_item_title">企业目标</p>
                <p class="home_culture_content_right_items_item_msg">行业标杆、重整生态</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_about"  :style="`background-image:url(${bgUrl3})`">
      <div class="home_about_title">
        关于我们
      </div> 
      <div class="home_about_english">ABOUT US</div>
      <div class="home_about_content">扬师傅科技有限公司，是一家互联网物流快运平台，本公司APP简称“扬师傅”，扬师傅以先进的信息数据管理系统，现代物流技术，高素质人才团队为基石，依托资源优势，以资本渗透，网络合作，真正做到了以低成本，高时效营运模式，为客户创造价值。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      bannerUrl:require('../../assets/home/home_banner.png'),
      bgUrl:require('../../assets/home/home_logo_img.png'),
      bgUrl1:require('../../assets/home/home_logo_img1.png'),
      bgUrl2:require('../../assets/home/home_bg.png'),
      bgUrl3:require('../../assets/home/home_bg2.png'),
      bannerList:[],
      value:''
    }
  },
  components:{

  },
  methods:{
    getBannerList(){
      this.$get('Banner' , {})
      .then(data => {
        this.bannerList = data;
      } , error => {
        this.$message.error(error);
      });
    },
    search(){
      if(!JSON.parse(localStorage.getItem('userMessage') || '{}').token){
        this.$eventBus.$emit('login');
      }else{
        if(!this.value){
          this.$message.error('请输入运单编号！');
          return
        }
        this.getDetails();
        // this.$router.push('/piece_order');
      }
    },
    // 先获取详情，获取到了跳转
    getDetails(){
        this.loading = true;
        this.$get('Order/' + this.value,{})
            .then(data => {
                this.$router.push({path:'/orderDetails',query:{orderId:this.value}});
                this.loading = false;
            } , error => {
                this.loading = false;
                this.$message.error(error);
            });
    },
    // 拼车
    goCarpooling(){
      if(!JSON.parse(localStorage.getItem('userMessage') || '{}').token){
        this.$eventBus.$emit('login','/piece_order');
      }else{
        this.$router.push('/piece_order');
      }
    },
    // 整车
    goVehicle(){
      if(!JSON.parse(localStorage.getItem('userMessage') || '{}').token){
        this.$eventBus.$emit('login','/place_order');
      }else{
        this.$router.push('/place_order');
      }
    },
    goDetails(item){
      // console.log(window)
      window.open('https://logistics-service-api.gymooit.cn//v1/app/Template/invitation2?id=' +item.id);
    }
  },
  created(){
    this.getBannerList();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.home{
  &_banner{
    width:100%;
    height: 600px;
    position: relative;
    cursor: pointer;
    &_swiper{
      height: 600px;
      background-repeat: no-repeat;
      background-size:cover;
       background-position: center;
    }
    &_content{
      width:1210px;
      height: 600px;
      // background:red;
      position: absolute;
      left:calc(50% - 580px);
      z-index: 2;
      &_login{
        width:390px;
        height: 348px;
        float: right;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 6px;
        margin-top:128px;
        text-align: center;
        &_title{
          font-size: 28px;
          font-weight: 400;
          color:#333333;
          margin-top:27px;
          span{
            color:#5999FF;
          }
        }
        &_line{
          display: inline-block;
          width:20px;
          height: 4px;
          line-height: 20px;
          margin-bottom: 10px;
          // margin-top: -10px;
          background: #5999FF;
        }
        &_order{
          display: inline-block;
          width:345px;
          height: 106px;
          border-radius: 6px;
          background-repeat:no-repeat ;
          background-size: 345px 106px;
          margin-bottom:16px;
        }
      }
      &_msg{
        float: left;
        margin-left:412px;
        img{
          width:331px;
          margin-top:225px;
        }
        p{
          font-size:28px;
          color:#fff;
          font-weight: 500;
          margin-top:12px;
        }
      }
    }
  }

  &_star{
    width:100%;
    padding:60px calc(50% - 610px) 0;
    position: relative;
    color:#333333;
    background:#fff;
    z-index: 100;
    &_header{
      position: absolute;
      width:790px;
      height: 100px;
      background: #0D8AEA;
      top:-50px;
      left:0;
      right:0;
      margin: auto;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      &_left,.home_star_header_center{
        width:120px;
        text-align: center;
        cursor: pointer;
        img{
          width:44px;
          height: 44px;
        }
        p{
          text-align: center;
          color:#fff;
        }
      }
      &_right{
        width:482px;
        height: 68px;
        background:#fff;
        margin-left:10px;
        display: flex;
        align-items: center;
        &_icon{
          width:30px;
          height: 30px;
          margin-left: 25px;
        }
        &_msg{
          display: inline-block;
          width:120px;
          text-align: center;
          font-size: 18px;
          font-weight: 400;
          height: 28px;
          line-height: 28px;
          border-right: 1px solid #333333;
          margin-right: 8px;
        }
        &_input{
          width:220px;
        }
        /deep/ .el-input__inner{
          width:220px;
          border:none;
          font-size: 18px;
          line-height: 18px;
          padding: 0 4px;
        }
        &_btn{
          width:68px;
          height: 44px;
          line-height: 44px;
          text-align: center;
          cursor: pointer;
          background: #FFB600;
          border-radius: 4px;
          font-size: 20px;
          font-weight: 500;
          color:#fff;
        }
      }
    }
    &_title{
      font-size: 28px;
      text-align: center;
      color:#333333;
      padding-top:50px;
      font-weight: 500;
      position: relative;
      z-index: 10;
    }
    &_english{
      width:1220px;
      position: absolute;
      font-size: 32px;;
      color:#DBE9FF;
      font-weight: 600;
      text-align: center;
      top: 8px;
      padding-top:110px;
      z-index: 1;
    }
    &_content{
      margin-top:50px;
      display: flex;
      justify-content: space-between;
      &_item{
        width:380px;
        text-align: center;
        padding-bottom: 20px;
        img{
          width: 380px;
          height: 320px;
        }
        &_title{
          margin-top:36px;
          font-size: 24px;
          color:#333;
          font-weight: 600;
        }
        &_msg{
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
  &_reason{
    width:100%;
    padding:50px calc(50% - 580px);
    position: relative;
    color:#333333;
    background: #fff;;
    &_title{
      font-size: 28px;
      text-align: center;
          color:#333333;
      // margin-top:50px;
      font-weight: 500;
      position: relative;
      z-index: 10;
    }
    &_english{
      width:1160px;
      position: absolute;
      font-size: 32px;;
      color:#DBE9FF;
      font-weight: 600;
      text-align: center;
      top: 58px;
      left: calc(50% - 580px);
    }
    &_content{
      display: flex;
      justify-content:space-between;
      margin-top:56px;
      margin-bottom:76px;
      &_item{
        width:256px;
        height: 252px;
        text-align: center;
        &_img{
          width:160px;
          margin:9px 0;
        }
        &_title{
          font-size: 20px;
          font-weight: 600;
          margin-bottom:8px;
        }
        &_msg{
          font-size: 16px;
          font-weight: 400;
        }
      }
      &_item:hover{
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
        border-radius: 16px;
      }
    }

  }
  &_culture{
    width:100%;
    height: 652px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom right;
    position: relative;
      padding:0 calc(50% - 580px);
    &_title{
      font-size: 28px;
      text-align: center;
      color:#333333;
      padding-top:56px;
      font-weight: 500;
      position: relative;
      z-index:100;
    }
    &_english{
      width:1160px;
      position: absolute;
      font-size: 32px;;
      color:#DBE9FF;
      font-weight: 600;
      text-align: center;
      top: 64px;
      z-index: 1;
    }
    &_content{
      display: flex;
      justify-content:space-between;
      &_left{
        width:590px;
        height: 360px;
        margin-top:75px;
        p{
          text-indent: 2em;
          font-size: 20px;
          color:#666666;
          font-weight: 400;
          margin-bottom:40px;
          line-height: 36px;
        }
      }
      &_right{
        margin-top:95px;
        position: relative;
        left:30px;
        &_items{
          display: flex;
          flex-wrap:wrap;
          margin-bottom:-40px;
          &_item{
            width:162px;
            height: 162px;
            background: #fff;
            border-radius: 10px;
            box-shadow: 4px 4px 8px 0px rgba(153, 175, 208, 0.1);
            transform:rotate(45deg);
            margin-left:100px;
            div{
              width: 180px;
              transform:rotate(-45deg);
              text-align: center;
              position: relative;
              left: -12px;
              top: 32px;
            }
            &_title{
              position: relative;
              top: -8px;
              font-size: 24px;
              color:#435070;
              font-weight: 600;
            }
            &_msg{
              font-size: 20px;
              color:#999;
            }
          }
        }
      }
    }
  }
  &_about{
    width:100%;
    height: 432px;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    padding:0 calc(50% - 580px);
    &_title{
      font-size: 28px;
      text-align: center;
      padding-top:80px;
      font-weight: 500;
      color:#fff;
      position: relative;
      z-index:100;
    }
    &_english{
      width:1160px;
      position: absolute;
      font-size: 32px;;
      color:#8E7F8A;
      font-weight: 600;
      text-align: center;
      top: 88px;
      z-index: 1;
    }
    &_content{
      // width:943px;
      line-height: 36px;
      text-indent: 2em;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size:20px;
      font-weight: 500;
      color:#fff;
      padding:0 108px;
      text-align: center;
      margin-top:77px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue